<template>
    <div class="stripe-invoice-create" :class="{loading: loading}">
        <a v-on:click="openModal"
        href="javascript://void(0)" class="btn btn-sm btn-info">
            Create One Time Invoice
        </a>

        <modal name="create-invoice"
            :adaptive="true"
            :scrollable="true"
            height="auto">
            <div class="dashboard-block">
                <header>
                    <h3>Create Invoice</h3>
                </header>
                <hr>
                <div class="stripe-invoice" :class="{loading: loading}">
                    <form @submit.prevent="saveInvoice" accept-charset="UTF-8" novalidate="novalidate">
                        <div class="row">
                            <div class="form-group has-feedback col-sm-8 col-md-6">
                                <label for="invoice-charge">Charge</label>

                                <div class="input-group" :class="{'has-error': errors.has('charge')}">
                                    <span class="input-group-addon">$</span>

                                    <input id="invoice-charge"
                                            aria-required="true"
                                            class="form-control"
                                            min="0"
                                            name="Invoice[charge]"
                                            required="required"
                                            type="number"
                                            v-model="invoice.total">
                                </div>

                                <span v-show="errors.has('charge')" class="help-block">
                                    {{ errors.first('charge') }}
                                </span>
                            </div>

                            <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('due_date')}">
                                <label for="invoice-due-date">Due Date</label>

                                <input id="invoice-due-date"
                                        class="form-control"
                                        name="Invoice[due_date]"
                                        v-model="invoice.due_date"
                                        type="date">

                                <span v-show="errors.has('due_date')" class="help-block">
                                    {{ errors.first('due_date') }}
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('statement_descriptor')}">
                                <label for="invoice-statement-descriptor">Statement Descriptor</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">Extra information about a charge for the customer’s credit card statement. It must contain at least one letter. Ex: Onboard RS</span></i>

                                <input id="invoice-statement-descriptor"
                                        class="form-control"
                                        name="Invoice[statement_descriptor]"
                                        v-model="invoice.statement_descriptor"
                                        type="text">

                                <span v-show="errors.has('statement_descriptor')" class="help-block">
                                    {{ errors.first('statement_descriptor') }}
                                </span>
                            </div>

                            <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('type')}">
                                <label for="invoice-type">Invoice Type</label>

                                <select name="invoice-type" id="invoice-type" v-model="invoice.type" class="form-control">
                                    <option value="1">Amenity Cancellation</option>
                                    <option value="2">Other</option>
                                </select>

                                <span v-show="errors.has('type')" class="help-block">
                                    {{ errors.first('type') }}
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group has-feedback col-sm-8 col-md-12" :class="{'has-error': errors.has('description')}">
                                <label for="invoice-description">Description</label> <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">Line item description displayed to the Customer when they open and pay invoice in Stripe's Dashboard</span></i>

                                <input id="invoice-description"
                                        class="form-control"
                                        name="Invoice[description]"
                                        v-model="invoice.description"
                                        type="text">

                                <span v-show="errors.has('description')" class="help-block">
                                    {{ errors.first('description') }}
                                </span>
                            </div>
                        </div>

                        <p><i>Note:</i> Invoice will be finalized immediately and Resident will be notified.</p>

                        <hr>

                        <div class="row">
                            <div class="col-xs-6">
                                <button type="button" class="btn btn-default" @click="$modal.hide( 'create-invoice' )">
                                    Cancel
                                </button>
                            </div>

                            <div class="col-xs-6 text-right">
                                <button type="submit" class="btn btn-block btn-success" :disabled="loading">
                                    Create Invoice
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    /**
     * Note: Cannot be nested within a form element with a non-https action
     */
    export default {
        props: {
            afterSave: {
                default: () => {
                    return function(){
                    };
                }
            },

            modalId: {
                default: function(){
                    return Math.random().toString();
                },
                type: String
            },

            stripeCustomerId: {
                type: String,
                required: true
            },

            initialAmount: {
                type: Number,
                required: false
            },

            brandSuffix: {
                type: String,
                required: false
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                style: {
                    base: {
                        color: '#282828',
                        fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#282828'
                        },
                        lineHeight: '26px',
                        padding: '8px'
                    },

                    invalid: {
                        color: '#C70039',
                        iconColor: '#900C3F'
                    }
                },

                elements: null,
                invoice: {
                    total: this.initialAmount,
                    due_date: null,
                    statement_descriptor: 'Onboard RS',
                    description: this.brandSuffix + ' Service Cancellation',
                    type: 1
                },
                stripe: null,
                stripeCustomer: {},
            };
        },

        methods: {
            init(){
                this.loading = true;

                return this.loadStripeCustomer()
                    .then( () => {
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            loadStripeCustomer(){
                var url = '/api/stripeCustomers/' + this.stripeCustomerId + '?_load[]=customer';

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'stripeCustomer', response.data.StripeCustomer );
                    } );
            },

            openModal(){
                this.$modal.show( 'create-invoice' );
            },

            saveInvoice(){
                this.loading = true;

                var url = '/api/stripeCustomers/' + this.stripeCustomerId + '/invoices';

                return axios.post(url, {
                    due_date: this.invoice.due_date,
                    charge: this.invoice.total,
                    statement_descriptor: this.invoice.statement_descriptor,
                    description: this.invoice.description,
                    type: this.invoice.type
                })
                    .then((response) => {
                        if ( response.data.errors ) {
                            this.errors.clear();
                            for (const [key, value] of Object.entries(response.data.errors)) {
                                this.errors.add({
                                    field: key,
                                    msg: value[0]
                                });
                            }
                        } else if ( response.data.error ) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: response.data.error,
                            } );
                        } else {
                            this.$modal.hide( 'create-invoice' );
                            this.$notify( {
                                type: 'success',
                                placement: 'top-left',
                                title: 'Invoice Created',
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    .catch( this.$root.handleErrors );
            },
        }
    }
</script>
